import React from 'react';
import { CheckCircle, ArrowRight } from 'lucide-react';

/**
 * StudyConclusionBox — Caixa de conclusões e takeaways práticos
 *
 * Props:
 *   title      — Título da seção (default: "Conclusões e Implicações")
 *   summary    — Texto de resumo executivo (1-2 parágrafos)
 *   takeaways  — Array de strings com pontos práticos
 *   nextSteps  — Array de strings com próximos passos (opcional)
 */
const StudyConclusionBox = ({
  title = 'Conclusões e Implicações',
  summary,
  takeaways = [],
  nextSteps = [],
}) => {
  if (!summary && !takeaways.length) return null;

  return (
    <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
      <div className="px-6 py-5 border-b border-gray-100">
        <h3 className="font-bold text-gray-900 text-lg flex items-center gap-2">
          <span className="text-xl">💡</span> {title}
        </h3>
      </div>

      <div className="px-6 py-5 space-y-5">
        {/* Executive summary */}
        {summary && (
          <p className="text-sm text-gray-700 leading-relaxed">{summary}</p>
        )}

        {/* Practical takeaways */}
        {takeaways.length > 0 && (
          <div>
            <p className="text-xs font-bold text-gray-500 uppercase tracking-wide mb-3">
              Conclusões práticas
            </p>
            <div className="space-y-2">
              {takeaways.map((t, i) => (
                <div key={i} className="flex items-start gap-3 bg-green-50 rounded-xl p-3">
                  <CheckCircle className="w-4 h-4 text-green-600 flex-shrink-0 mt-0.5" />
                  <span className="text-sm text-gray-700">{t}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Next steps */}
        {nextSteps.length > 0 && (
          <div>
            <p className="text-xs font-bold text-gray-500 uppercase tracking-wide mb-3">
              Próximos estudos possíveis
            </p>
            <div className="space-y-2">
              {nextSteps.map((s, i) => (
                <div key={i} className="flex items-start gap-3 bg-blue-50 rounded-xl p-3">
                  <ArrowRight className="w-4 h-4 text-blue-600 flex-shrink-0 mt-0.5" />
                  <span className="text-sm text-gray-700">{s}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default StudyConclusionBox;
